'use client'
import React, {useEffect, useState} from 'react'
import {useOrganziationTheme} from 'organization/theme/OrganizationThemeProvider'
import {Menu} from 'organization/theme/Sidebar/Menu'

const DashbordSidebar = (props: {menu?: React.JSX.Element}) => {
  const {isCollapse, SidebarHandle} = useOrganziationTheme()

  const [deviceWidth, setDeviceWidth] = useState<number | null>(null)
  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      {deviceWidth && deviceWidth <= 991 ? (
        <div
          onClick={SidebarHandle}
          className={
            isCollapse ? 'expovent__sidebar' : 'expovent__sidebar open'
          }
        >
          {props.menu ?? <Menu />}
        </div>
      ) : (
        <div className={`expovent__sidebar ${isCollapse ? 'collapsed' : ' '}`}>
          {props.menu ?? <Menu />}
        </div>
      )}
      <div
        onClick={SidebarHandle}
        className={`app__offcanvas-overlay ${isCollapse ? '' : 'overlay-open'}`}
      ></div>
    </>
  )
}

export default DashbordSidebar
